import { render, staticRenderFns } from "./InventoryReservationCreate.vue?vue&type=template&id=52f6811d"
import script from "./InventoryReservationCreate.vue?vue&type=script&lang=js"
export * from "./InventoryReservationCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports